<template>
    <div>
        <b-container fluid class="pb-6 pb-8 pt-5 pt-md-8">
            <b-row >
                <b-col col sm="12">
                    <div class="card shadow">
                        <div class="pt-3">
                            <h3 class="text-center pb-2">{{$t('message.searchPatient')}}</h3>
                            <section class="container" id="appointment-table">
                                <div class="appointment-table-header my-2 mb-4">
                                    <div class="row">
                                        <div class="col-12">
                                            <b-input-group
                                                    class="mb-3"
                                            >
                                                <b-form-input
                                                        type="text"
                                                        class="p-2"
                                                        :placeholder="$t('message.search') + '...'"
                                                        v-model="filterCriteria"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button
                                                            size="sm"
                                                            text="Button"
                                                            variant="primary"
                                                            @click="handlerOnFilterButton"
                                                    >
                                                        Go
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-4">
                                            <div class="ml-1">
                                                <div class="d-flex">
                                                   
                                                    <b-form-select
                                                            class="d-inline-block mr-2"
                                                            v-model="sortSelected"
                                                            size="sm"
                                                            :options="sortOptions"></b-form-select>
                                                    <div class="">
                                         

                                                     </div>
                                                    <div>
                                                        <b-button-group size="sm" class="mr-1">
                                                            <b-button
                                                                    :disabled="sortDirection === 'asc'"
                                                                    class="btn"
                                                                    size="sm"
                                                                    @click="sortDirection='asc'"
                                                            >
                                                                <i class="fa fa-sort-amount-up-alt"></i>
                                                            </b-button>
                                                            <b-button
                                                                    :disabled="sortDirection === 'desc'"
                                                                    class="btn"
                                                                    size="sm"
                                                                    @click="sortDirection='desc'"
                                                            >
                                                                <i class="fa fa-sort-amount-down-alt"></i>
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-8 overflow-auto">
                                            <div class="ml-1">
                                                <div
                                                        v-if="paginationObject!==null && paginationObject.numOfPages > 1"
                                                        class="pagination-wrapper d-inline-block"
                                                >
                                                    <div class="pagination">
                                                        <a
                                                                href="#"
                                                                :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('prev')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                        </a>
                                                        <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                            <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                            </template>
                                                            <template v-else>
                                                                <a
                                                                        href="#"
                                                                        :key="key"
                                                                        class="page-numbers"
                                                                        @click="_handlePaginationClick(pageNumber)"
                                                                >
                                                                    {{ pageNumber }}
                                                                </a>
                                                            </template>
                                                        </template>
                                                        <a
                                                                href="#"
                                                                class="next page-numbers"
                                                                :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('next')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row appointment-table-content" v-if="loading">
                                    <div class="text-center">
                                    <b variant="primary" label="Text Centered">  Recherche en cours......</b>
                                    </div>
                                </div>
                                <div class="row appointment-table-content" v-else>
                                    <div class="container-fluid">
                                        <template
                                                v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0"
                                        >
                                            <div
                                                    v-for="(patient, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                    :key="key"
                                                    class="row appointment-item hovered"
                                                    @click="onPatientPerInstCellClick({row: patient})"
                                            >
                                                <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $tc('message.patients', 1) }}
                                                        </span>
                                                    <h4 class="appointment-date">{{ patient.nom }}</h4>
                                                </div>
                                                <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.fileNumber') }}
                                                        </span>
                                                    <h4 class="appointment-hour">
                                                        {{ patient.dossier }}
                                                    </h4>
                                                </div>
                                                <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.old') }}
                                                        </span>
                                                    <h4 class="appointment-hour">
                                                        {{ patient.age }}
                                                    </h4>
                                                </div>
                                                <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.email') }}
                                                        </span>
                                                    <h4 class="appointment-hour">
                                                        {{ patient.email }}
                                                    </h4>
                                                </div>
                                            </div>
                                        </template>

                                        <template v-else>
                                            <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                        </template>

                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';
    import { ModelSelect } from 'vue-search-select';
    import Swal from 'sweetalert2';
	import {pagination, handlePaginationClick, paginationDataProperty} from "../../helpers/paginations";
    import loading from 'vue-loading-overlay';
    export default {
        name: "PractionerDashboard",

        computed: {
            ...mapGetters(["patients",
                "selectedInstitution",
                "userInstitutions",
                "institutions",
                'hasAdminRole',
                'hasGestionnaireRole',
                'hasMedecinControleRole',
                'hasPatientRole',
                'hasSouscripteurRole',
                "operations"
            ]),
            mafunction(){
                // console.log("ici mm");
                // console.log(this.paginationObject);
            }
            

            
        },

        components: {
            ModelSelect
        },
        watch: {
            item(newValue, lastValue){
                // console.log("on est ici 1");
                if (newValue.value != '0'){
                    this.onEtablissementClick(newValue.value);
                }
                else{
                    this.$store.dispatch('setselectedInstitution', { selectedInstitution : {} });
                }
            },

            filteredValue(sArray,value){
             
             this.typeFilter(this.currentPatientArrayFiltered);
            },

            searchTerm:function (newValue, oldValue) {
                
                if (newValue.trim().length ==0){
                    this.patientPeInstitutionsRowsFilter = [];
                }else{
                    this.patientPeInstitutionsRowsFilter = this.mPatients;
                }

            },

			institutions: function (newValue, oldValue) {
				if (!this.shouldDisplay) {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
				} else {
					this.currentPatientArray = this.mPatients();
					this.currentPatientArrayFiltered = this.currentPatientArray;
				}
			},

			currentPatientArray: function (newValue, oldValue) {
				this.paginationObject = pagination(newValue);
			},

			filterCriteria: async function (newValue, oldValue) {
                
				if (newValue.length >= 3) {
                    this.loading=true;
                    await this.getSearchPatient(newValue)
                    this.loading=false;
                        //console.log(this.patients);
                    if(!this.shouldDisplay)
					    this.shouldDisplay = true;
                    
                    this.currentPatientArray = this.mPatients();
					this.currentPatientArrayFiltered = this.currentPatientArray;
                    
					this.handleFilter(newValue);
                    
                    
				}
                if (newValue.length > 15) {

                    if(!this.shouldDisplay)
					    this.shouldDisplay = true;
                    
					this.handleFilter(newValue);
                    
                    
				}
			},

			sortDirection: function (newValue, oldValue) {
				this.handleSort(this.sortSelected ,newValue);
			},

			sortSelected: function (newValue, oldValue) {
				this.handleSort(newValue, this.sortDirection);
			},

			shouldDisplay: function (newValue, oldValue) {
				if (newValue) {
					this.currentPatientArray = this.mPatients();
					this.currentPatientArrayFiltered = this.currentPatientArray;
				} else {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
				}
			}
        },
        data() {
            return {
                
				...paginationDataProperty(this.$i18n),
                filtered:[
                    {value:1,text:'Tous'},
                    {value:2,text:'Non Archivés'},
                    {value:3,text:'Non Transmis'},
                    {value:4,text:'Archivés'},
                    {value:5,text:'Transmis'},
                ],
                filteredValue:null,
				shouldDisplay: false,
                loading:false,
                patientPeInstitutionsRowsFilter: [],

                searchTerm : '',

                item: {
                    value: '',
                    text: ''
                },

                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled: {enabled: true},

                sort: {
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },

                operationsColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'nom',
                    },
                    {
                        field: 'element',
                        label: this.$i18n.tc('message.operations', 1)
                    },
                    {
                        field: 'action',
                        label: this.$i18n.t('message.action')
                    },
                ],

                patientPeInstitutionsColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'nom',
                    },
                    {
                        field: 'dossier',
                        label: this.$i18n.t('message.fileNumber')
                    },
                    {
                        field: 'age',
                        label: this.$i18n.t('message.old')
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email')
                    },
                ],

                etablissementsColumns: [
                    {
                        label: this.$i18n.t('message.name'),
                        field: 'nom',
                    },
                    {

                        label: this.$i18n.t('message.description'),
                        field: 'description'
                    },
                ],
            }
        },

        methods:{

            mPatients() {

                
                let pArray = [];
                    _.forEach(this.patients, function(patient) {
                        let p = {};

                        if ((typeof patient.user == 'object') && !_.isNull(patient.user)) {
                            let prenom = patient.user.prenom ? patient.user.prenom : '';
                            prenom =  prenom.toLowerCase();
                            p.nom =  (patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            p.dossier = patient.dossier.numero_dossier;
                            p.email = patient.user.email;
                            p.telephone = patient.user.telephone;
                            p.age = moment().year() - moment(patient.date_de_naissance).year();
                            p.sexe = patient.sexe;
                            p.nationalite = patient.user.nationalite;
                            p.ville = patient.user.ville;
                            p.pays = patient.user.pays;
                            p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                            p.id = patient.user.id;
                            p.slug = patient.user.slug;
                            p.adresse = patient.user.adresse;
                            p.fileSlug = patient.dossier.slug;
                            if(!_.isUndefined(patient.etablissements[0]))
                            p.institutionId = patient.etablissements[0].id;
                            

                                

                        }
                        let hasPatient =  _.filter(pArray,function (item) {
                            if(item.dossier == p.dossier)
                                return p;
                        })
                        if(_.isEmpty(hasPatient)){
                            pArray.push(p);
                        }
                    });
                   
                return pArray;
            },

            mInstitutions: function() {
                let iArray = [];
                let self = this;
                // let self = this;
                _.forEach(this.institutions, function(institution) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = institution.description;
                    i.etablissementId = institution.id;
                    // i.id = institution.id + patient.user_id;
                    i.slug = institution.slug;
                    iArray.push(i);
                });

                return iArray;
            },
            mUserInstitutions: function() {
                let iArray = [];
                _.forEach(this.userInstitutions, function(institution) {

                    let i = {};

                    i.nom = institution.name;
                    i.description = institution.description;
                    i.etablissementId = institution.id;
                    i.id = institution.id;
                    i.slug = institution.slug;
                    i.patients = institution.patients;
                    iArray.push(i);
                });
                return iArray;
            },

            options:function(){
                let oArray = [];

                _.forEach(this.mInstitutions, function (institution) {
                    oArray.push({value:institution.etablissementId, text:  institution.nom});
                })  ;
                oArray.push({value:'0',text:'All'});
                return oArray;
            },

            operationsRows:function(){
                let oArray = [];
                let self = this;
                //Ici on va filtrer pour ne laisser que les patients qui sont dans l'etablissement selectionné
                let selectedOperations = [];

                _.forEach(this.operations,function (operation) {
                    if(typeof operation.user == "object"){
                        if (operation.hasOwnProperty('dossier')) {
                            selectedOperations.push(operation);
                        }
                    }
                });

                _.forEach(selectedOperations, function(operation) {

                    if(typeof operation.user == "object"){
                        if (operation.hasOwnProperty('dossier')){
                            let user = operation.user;
                            let dossier = operation.dossier;

                            let action = operation.action;
                            let nom = self.formatString((user.prenom ? ' ' + user.prenom : '') + "  " +  (user.nom).toUpperCase()) + " ( "
                                +dossier.numero_dossier + " )";
                            let element = self.formatString(operation.operationable_type);
                            let fileSlug = dossier.slug;
                            oArray.push({nom: nom, element: element, action: action, fileSlug:fileSlug});
                        }
                    }
                });

                return oArray;
            },

            mOperations:function(){
                let oArray = [];
                let self = this;
                _.forEach(this.operations, function(operation) {

                    if(typeof operation.user == "object"){
                        if (operation.hasOwnProperty('dossier')){
                            let user = operation.user;
                            let dossier = operation.dossier;
                            let o = {};

                            o.id = operation.id;
                            o.action = operation.action;
                            o.slug = user.slug;
                            o.onom = self.formatString((user.prenom ? ' ' + user.prenom : '') + "  " +  (user.nom).toUpperCase()) + " ( "
                                +dossier.numero_dossier + " )";
                            o.oslug = user.slug;
                            o.element = self.formatString(operation.operationable_type);
                            o.oFileSlug = dossier.slug;
                            oArray.push(o);
                        }

                    }

                });

                return oArray;
            },

            rows: function() {
                return this.mInstitutions.length;
            },

            operationRows: function() {
                return this.mOperations.length;
            },

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            

            hasSelectInstitution:function () {
                return _.isNull(this.selectedInstitution) || _.isEmpty(this.selectedInstitution);
            },

            patientPeInstitutionsRows:function () {
                let iArray = [];
                let institutions = [];
                if(!_.isNull(this.selectedInstitution) && !_.isEmpty(this.selectedInstitution)) {
                    institutions = this.selectedInstitution;
                }
                else{
                    institutions = this.institutions;
                }
                _.forEach(institutions, function(institution) {
                    if(typeof institution.patients == "object"){
                        let pArray = [];
                        _.forEach(institution.patients, function(patient) {
                            if(!_.isNull(patient.dossier) && !_.isNull(patient.user)){
                                let prenom = patient.user.prenom ? patient.user.prenom : '';
                                prenom =  prenom.toLowerCase();

                                let infoPatient = (patient.user.nom).toUpperCase() +" "+ (prenom.charAt(0)).toUpperCase() + prenom.substring(1)+ " ( "
                                    +patient.dossier.numero_dossier + " )";
                                pArray.push({institution:institution.name, infoPatient:infoPatient, fileSlug:patient.dossier.slug, institutionSlug:institution.slug});
                            }
                        });

                        iArray.push({mode: "span", label: institution.name, html:false,
                            children: pArray
                        });
                    }

                });

                return iArray;
            },

			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
			},

			handleFilter(value) {
                
				if (value) {

                    if(value.length==1){
                        const newCurrentPatientArray=this.currentPatientArray;

                        this.currentPatientArrayFiltered = newCurrentPatientArray;

					    this.paginationObject = pagination(newCurrentPatientArray);
                    }
                    
                    if(value.length>1){
                        // console.log("ou bien?")
                        const newCurrentPatientArray = this.currentPatientArray.filter(app => {
                            let result = false;

                            if (app.nom) {
                                result = result || app.nom.toLowerCase().includes(value.toLowerCase());
                            }

                            if (app.dossier) {
                                result = result || app.dossier.toString().toLowerCase().includes(value.toLowerCase());
                            }

                            if (app.age) {
                                result = result || app.age.toString().toLowerCase().includes(value.toLowerCase());
                            }

                            if (app.email) {
                                result = result || app.email.toLowerCase().includes(value.toLowerCase());
                            }

                            return result;
                        });

                        this.currentPatientArrayFiltered = newCurrentPatientArray;

                        this.paginationObject = pagination(newCurrentPatientArray);
                    }
					
					
				} else {
					this.currentPatientArrayFiltered = this.currentPatientArray;
					this.paginationObject = pagination(this.currentPatientArray);
				}
                this.filteredValue=this.paginationObject;
			},

			handleSort(value, sortDirection = 'asc') {
                
				if (value) {
					let newCurrentPatientArray = [];
					const sortType = ['nom', 'dossier', 'age', 'email'];
					const restOfType = sortType.filter(i => i !== value);

					const sortDirectionType = ['asc', 'desc'];
					const restOfSortDirectionType = sortDirectionType.filter(i => i !== sortDirection);

					newCurrentPatientArray = _.orderBy(this.currentPatientArrayFiltered, [value, ...restOfType], [sortDirection, ...restOfSortDirectionType]);

					this.paginationObject = pagination(newCurrentPatientArray);
				} else {
					this.paginationObject = pagination(this.currentPatientArrayFiltered);
				}
			},
			typeFilter(value, ) {
                
                // console.log(value)
                      if (this.filteredValue == 2){
                            //Non archivés
                            value = _.filter(value,function (medecine) {
                            return _.isNull(medecine.archievedAt);
                            })
                        }else if (this.filteredValue == 3){
                            //Non transmis
                            value = _.filter(value,function (medecine) {
                            return _.isNull(medecine.passedAt);
                            })
                        }else if (this.filteredValue ==4){
                            //Archivés
                            value = _.filter(value,function (medecine) {
                            return !_.isNull(medecine.archievedAt);
                            })
                        }else if (this.filteredValue == 5){
                            //Transmis
                            value = _.filter(value,function (medecine) {
                            return !_.isNull(medecine.passedAt);
                            })
                        }
				if (value) {
					this.paginationObject = pagination(value);
				} else {
					this.paginationObject = pagination(this.currentPatientArrayFiltered);
				}
			},
			onEtablissementClick(etablissementId){
                let etablissement = _.filter(this.institutions,function (institution) {
                    return institution.id == etablissementId;
                });
                this.$store.dispatch('setselectedInstitution', { selectedInstitution : etablissement });
            },

            onOperationClick(params){
                // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file: params.row.fileSlug } })).href +  '#generale');

            },

            onPatientPerInstCellClick(params){
                // if (params.column.field == "institution")
                //     this.$router.push({ name: 'institution', params: { institution: params.row.institutionSlug } });
                // else
                let isPraticienPatient=_.find(this.mUserInstitutions,function (institution) {

                    let patient = _.find(institution.patients, function (patient) {
                        return  patient.user_id == params.row.id;
                    });
                    if(_.isUndefined(patient))
                        return patient;
                    return institution;
                });
                localStorage.setItem("dossier_medical_slug", params.row.fileSlug);

                if (_.isUndefined(isPraticienPatient)){
                    Swal.fire({
                        title: 'Êtes vous sûr ?',
                        text: "Ce patient n'appartient pas à l'un de vos établissements. Vous serez fichié dans le système si vous y accédez",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#00ada7',
                        cancelButtonColor: '#f5365c',
                        confirmButtonText: 'Oui, accéder!'
                    }).then((result) => {
                        if (result.value) {
                            // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                            this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file:params.row.fileSlug } })).href +  '#generale');

                        }
                    })
                }else{
                    // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                    this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file:params.row.fileSlug } })).href +  '#generale');

                }
            },

            notEmpty(item){
                return item.length > 0;
            },

            loadForm() {
                // console.log("on est ici d'abord?");
                // console.log(this.shouldDisplay);
				if (!this.shouldDisplay) {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
				} else {
					this.currentPatientArray = [...this.mPatients];
					this.currentPatientArrayFiltered = this.currentPatientArray;
				}
			},

            getInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getInstitutions', { args : args });
            },

            async getSearchPatient(value) {
                // console.log("juste pour vérifier");
                let args = {
                    patient: value
                };

                await this.$store.dispatch("getSearchPatient", {
                    args : args
                });
            },

            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },


            getLatestOperation() {
                let args = {

                };

                this.$store.dispatch('getOperations', { args : args });
            },


            formattedDisplay (result) {
                return result.nom;
            },

            itemSelected(item) {
                this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file: item.selectedObject.fileSlug } })).href +  '#generale');
            },

            formatString(item){
                return item.length > 36 ? item.substr(0, 36) + '...' : item;
            },

        },

        mounted() {
            this.loadForm();
            // Fetch patient list
            // this.getPatients();

            // Fetch institution list
            // this.getInstitutions();

            // Fetch user institution list
            // this.getUserInstitutions();

            // Fetch institution list
            // this.getLatestOperation();

        }
    }
</script>

<style scoped>
</style>